module.exports = __webpack_public_path__ + "static/media/moviesThumbnail.271af355.png";